import { Fields } from '@measured/puck';
import { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Switch, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import InputField from '../../../components/common/input-field';

export type HyperLinkType = {
  useLink: boolean;
  link: string;
};

export type HyperLinkProps = {
  hyperlink: HyperLinkType;
};

export const hyperLinkFields: Fields<HyperLinkProps> = {
  hyperlink: {
    type: 'custom',
    label: 'Radius',
    render: ({ value, onChange }) => {
      const [isOpen, setIsOpen] = useState(false);

      const toggleAccordion = () => {
        setIsOpen(!isOpen);
      };

      return (
        <div>
          <div
            className=" flex justify-between font-bold cursor-pointer py-2 bg-slate-100 rounded-md pagebuilder-theme"
            onClick={toggleAccordion}>
            <h3>Add Hyperlink</h3>
            {!isOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
          </div>
          {isOpen && (
            <div className="flex flex-col gap-4 mt-3 border border-gray-300 rounded p-2 w-full">
              <div className="flex justify-between items-center mb-3">
                <p className="text-sm font-semibold">Use Hyperlink</p>
                <div className="flex gap-0.5 items-center">
                  <Tooltip
                    title={'Toggle this switch to use Hyperlink'}
                    placement="top-start">
                    <InfoIcon fontSize="small" className="h-1 w-1" />
                  </Tooltip>
                  <Switch
                    onChange={e => {
                      onChange({ ...value, useLink: e.target.checked });
                    }}
                    checked={value.useLink}
                    inputProps={{ 'aria-label': 'controlled' }}
                  />
                </div>
              </div>
              {value.useLink && (
                <InputField
                  label="Hyperlink"
                  className="mt-2"
                  value={value.link}
                  onChange={e => {
                    onChange({ ...value, link: e });
                  }}
                  placeholder="Enter Hyperlink"
                />
              )}
            </div>
          )}
        </div>
      );
    },
  },
};
